var _linearGradient, _radialGradient, _linearGradient2, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient3, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _circle2, _path17, _path18, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "network_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#c0dae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#bad6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8abbd5"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__d",
    cx: 235.682,
    cy: 353.329,
    r: 76.734,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "network_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3692bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#0681af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#0055a3"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__e",
    cx: 297.941,
    cy: 324.953,
    r: 84.809,
    gradientTransform: "matrix(0 1 -.609 0 495.923 27.012)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__b"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__f",
    cx: 389.282,
    cy: 323.294,
    r: 67.878,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__a"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__g",
    cx: 451.541,
    cy: 302.657,
    r: 63.603,
    gradientTransform: "matrix(0 1 -.609 0 635.938 -148.884)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__b"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__h",
    cx: 82.082,
    cy: 323.294,
    r: 67.878,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__a"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__i",
    cx: 144.341,
    cy: 302.657,
    r: 63.603,
    gradientTransform: "matrix(0 1 -.609 0 328.738 158.316)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__b"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__j",
    cx: 351.868,
    cy: 2408.224,
    r: 211.111,
    gradientTransform: "matrix(.931 0 0 .114 -74.264 212.159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1f4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#e9f9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "#e9f9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "network_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#d6f6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68e7fd"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__k",
    cx: 214.418,
    cy: -6.58,
    r: 97.427,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__c"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__l",
    cx: 97.269,
    cy: 51.994,
    r: 87.953,
    gradientTransform: "matrix(1 0 0 .763 0 12.31)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__c"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__m",
    cx: 57.349,
    cy: 178.745,
    r: 161.174,
    gradientTransform: "matrix(1 0 0 .573 0 76.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1693,
    stopColor: "#42e3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#00dcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    stopColor: "#00c1fc"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__n",
    cx: 49.388,
    cy: 108.905,
    r: 80.486,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#network_svg__c"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__o",
    cx: 502.007,
    cy: 60.696,
    r: 437.907,
    gradientTransform: "matrix(-1 0 0 -.504 1004.014 91.264)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#00c1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#0094ff"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__p",
    cx: 228.099,
    cy: 461.094,
    r: 68.099,
    gradientTransform: "matrix(1 0 0 .325 0 311.417)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#a4ed62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7855,
    stopColor: "#85e026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#72d800"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__q",
    cx: 211.798,
    cy: 378.929,
    r: 77.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#ddf7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    stopColor: "#daf7c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#c4f19b"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__r",
    cx: 327.871,
    cy: 433.141,
    r: 126.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7be700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#72d800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8085,
    stopColor: "#26b847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#00a96a"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__s",
    cx: 74.127,
    cy: 422.694,
    r: 68.099,
    gradientTransform: "matrix(1 0 0 .325 0 285.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#fff485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#ffed26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#ffea00"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__t",
    cx: 57.826,
    cy: 340.529,
    r: 77.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#fffacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#fff6ab"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__u",
    cx: 173.899,
    cy: 394.741,
    r: 126.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    stopColor: "#fbd113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#f6ab31"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__v",
    cx: 381.699,
    cy: 422.694,
    r: 68.099,
    gradientTransform: "matrix(1 0 0 .325 0 285.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcb9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#ffba7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    stopColor: "#ffa850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#ff982a"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__w",
    cx: 365.398,
    cy: 340.529,
    r: 77.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5354,
    stopColor: "#ffe4cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    stopColor: "#ffdfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9729,
    stopColor: "#ffcb9b"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "network_svg__x",
    cx: 481.471,
    cy: 394.741,
    r: 126.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#ff982a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5978,
    stopColor: "#ff8f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#ff6927"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__d)",
    d: "M243.2 243.2H256l12.8 76.799L256 384h-12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__e)",
    d: "M256 243.2h25.6V384H256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__f)",
    d: "M396.8 243.2h12.8l12.8 76.799-12.8 25.601h-12.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__g)",
    d: "M409.6 243.2h25.6v102.4h-25.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__h)",
    d: "M89.6 243.2h12.8l12.8 76.799-12.8 25.601H89.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__i)",
    d: "M102.4 243.2H128v102.4h-25.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__j)",
    d: "M256 512c113.107 0 204.798-11.462 204.798-25.6H51.202c0 14.138 91.691 25.6 204.798 25.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__k)",
    d: "M321.6 0c-46.824 0-79.536 43.979-104 80l-85.382-20.314C156.682 23.665 197.976 0 244.8 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__l)",
    d: "M54.591 113.377a54.987 54.987 0 01-.191-4.577c0-30.044 24.356-54.4 54.4-54.4h76.8c-30.044 0-54.335 57.468-54.209 58.977z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__m)",
    d: "M81.6 272C36.534 272 0 235.466 0 190.4l115.2-33.6c0 45.066-1.866 115.2 43.2 115.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__n)",
    d: "M0 190.4c0-35.6 22.798-65.875 54.591-77.023h76.8c-31.793 11.148-16.192 41.423-16.192 77.023z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__o)",
    d: "M455.622 112.773C444.6 48.728 388.791 0 321.6 0c-46.824 0-88.118 23.665-112.582 59.686A54.187 54.187 0 00185.6 54.4c-30.044 0-54.4 24.356-54.4 54.4 0 1.541.065 3.068.191 4.577C99.598 124.525 76.8 154.8 76.8 190.4c0 45.066 36.534 81.6 81.6 81.6h272c45.066 0 81.6-36.534 81.6-81.6 0-36.264-23.656-67.003-56.378-77.627z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__p)",
    d: "M256 447.999l-54.054 12.613c10.316 15.542 27.974 25.788 48.026 25.788H275.2c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__q)",
    d: "M275.2 371.2h-25.228c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h52.98c-8.555-33.96-1.797-89.412 20.274-89.412z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 275.2,
    cy: 428.8,
    r: 57.6,
    fill: "url(#network_svg__r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__s)",
    d: "M102.028 409.599l-54.054 12.613C58.29 437.754 75.948 448 96 448h25.228c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__t)",
    d: "M121.228 332.8H96c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h52.98c-8.555-33.96-1.797-89.412 20.274-89.412z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.228,
    cy: 390.4,
    r: 57.6,
    fill: "url(#network_svg__u)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__v)",
    d: "M409.6 409.599l-54.054 12.613C365.862 437.754 383.52 448 403.572 448H428.8c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#network_svg__w)",
    d: "M428.8 332.8h-25.228c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h52.98c-8.555-33.96-1.797-89.412 20.274-89.412z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 428.8,
    cy: 390.4,
    r: 57.6,
    fill: "url(#network_svg__x)"
  })));
}
export default __webpack_public_path__ + "static/network.4b31eed4.svg";
export { SvgNetwork as ReactComponent };